export default {"src":"/_next/static/media/vib.e30273a5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};